import { useEffect } from 'react';
import { messaging, VAPID_KEY } from './firebase';
import { getToken, onMessage } from 'firebase/messaging';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useSelector } from 'react-redux';

export default function FCMHandler() {
  const user = useSelector((state) => state?.user?.user);

  useEffect(() => {
    async function initFCM() {
      try {
        // const deleted = await deleteToken(messaging);
        const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });

        if (!currentToken) {
          console.log(
            "No registration token available. Request permission to generate one."
          );
          return;
        }

        console.log("FCM Token:", currentToken);

        const body = {
          providerId: user?.providerId,
          fcm_token: currentToken,
          // notification_preferences: {
          //   sessionRemindersNotification: true,
          //   newSessionNotification: true,
          //   cancelAndRescheduleNotification: true
          // },
        };

        const headers = {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        };

        const response = await axios.put(
          `${process.env.REACT_APP_BASE_URL}/specialist/update-settings`,
          body,
          { headers }
        );

        console.log("FCM token saved successfully", response.data);

      } catch (error) {
        console.error("Failed to update FCM token on server:", error);
      }
    }

    initFCM();

    // Foreground message listener
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('📩 Foreground notification received:', payload);
      const { id } = payload.data || {};
      const { title, body } = payload.notification || {};

      const sentAt = new Date().toISOString();
      const event = new CustomEvent("fcm-notification", {
        detail: { id, title, body, sentAt, isRead: false },
      });
      toast.info(body);
      window.dispatchEvent(event);
    });

    // Background FCM listener via postMessage from service worker
    const handleSWMessage = (event) => {
      if (event.data?.type === 'BACKGROUND_FCM') {
        console.log('📩 Background notification received in page:', event.data.detail);
        toast.info(event.data.detail);
        window.dispatchEvent(new CustomEvent("fcm-notification", {
          detail: event.data.detail
        }));
      }
    };
    
    navigator.serviceWorker.addEventListener('message', handleSWMessage);

    return () => {
      unsubscribe();
      navigator.serviceWorker.removeEventListener('message', handleSWMessage);
    };
  }, [user]);

  return null; // no UI
}